var _ellipse, _rect, _g, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDistribution(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 14,
    rx: 14,
    ry: 14,
    fill: "#99CCFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1872_138667",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 11,
    width: 29,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 11,
    width: 29,
    height: 15,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1872_138667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 11.5,
    width: 28,
    height: 14,
    rx: 1.5,
    fill: "white",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 25L23.5 14M37 3L23.5 14M23.5 14H32.5V20L37.5 20.5",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 26L19 19",
    stroke: "#333333"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6777 14C21.6777 19.2467 17.4244 23.5 12.1777 23.5C6.93103 23.5 2.67773 19.2467 2.67773 14C2.67773 8.75329 6.93103 4.5 12.1777 4.5C17.4244 4.5 21.6777 8.75329 21.6777 14Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4707 19.6406C11.9297 19.6406 13.0547 18.8408 13.3799 17.8213H13.4502V19.5H17.0537V6.81738H13.4502V11.5459H13.3799C13.002 10.4561 11.9473 9.65625 10.5322 9.65625C8.11523 9.65625 6.69141 11.502 6.69141 14.6221C6.69141 17.7861 8.08008 19.6406 10.4707 19.6406ZM11.9209 12.4336C12.8877 12.4336 13.4678 13.2686 13.4678 14.6572C13.4678 16.0547 12.8965 16.8633 11.9209 16.8633C10.9453 16.8633 10.3828 16.0371 10.3828 14.6484C10.3828 13.2773 10.9541 12.4336 11.9209 12.4336Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 12L32 12L36.5 12L32.6788 16.5396C32.2733 17.0213 31.5288 17.0129 31.1343 16.522L27.5 12Z",
    fill: "#1B3D81"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 14C35.3137 14 38 11.3137 38 8C38 4.68629 35.3137 2 32 2C28.6863 2 26 4.68629 26 8C26 11.3137 28.6863 14 32 14ZM32 11C33.6569 11 35 9.65685 35 8C35 6.34315 33.6569 5 32 5C30.3431 5 29 6.34315 29 8C29 9.65685 30.3431 11 32 11Z",
    fill: "#1B3D81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistribution);
export default __webpack_public_path__ + "static/media/Distribution.a382fd86b72941390baa94162aa28e2e.svg";
export { ForwardRef as ReactComponent };